let WEBFLOW_SCRIPT_ENV: 'dev' | 'staging' | 'production';

let url;

if (typeof window !== 'undefined') {
  url = window.location.href;
}

if (url && url?.indexOf('storeflow-landing-page.webflow.io') > -1) {
  WEBFLOW_SCRIPT_ENV = 'dev';
} else if (
  url &&
  (url?.indexOf('flowphantom.com') > -1 ||
    url?.indexOf('elevatedcollections.com') > -1)
) {
  WEBFLOW_SCRIPT_ENV = 'staging';
} else {
  WEBFLOW_SCRIPT_ENV = 'production';
}

if (WEBFLOW_SCRIPT_ENV !== 'production') {
  console.log('WEBFLOW_SCRIPT_ENV', WEBFLOW_SCRIPT_ENV);
}

export { WEBFLOW_SCRIPT_ENV };
